import React from "react";

import {
  KeyValue,
} from '../../types';

import {
  HeaderBar,
} from '../../components';

interface LinksBarProps {
  active: string,
  handleLink: any,
};

const items: KeyValue[] = [
  {
    key: 'filtro',
    value: 'Filtro'
  },

  {
    key: 'grafico',
    value: 'Gráfico'
  },

  {
    key: 'percentil',
    value: 'Tabela Percentil'
  },
];

const LinksBar: React.FC<LinksBarProps> = ({ active, handleLink }) => {
  return (
    <HeaderBar
      active={ active }
      items={ items }
      onClick={ handleLink }
    />
  );
}

export default LinksBar;